export default __webpack_public_path__ + "static/media/empViewProduct.ded1c321.png";